import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements, modifiers } from '../../styles.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    element
  ) => {
    const form = closest('form[name="registrar_results"]', element)
    const checkboxes = all(`.${elements.registrar_available} input[type='checkbox']`, form)
    const formFooter = one(`.${elements.form_registrar_results_footer}`, form)

    for (const checkbox of checkboxes) {
      if (checkbox.checked) {
        formFooter.classList.remove(utilities.modifiers.display.none)
        break
      } else {
        formFooter.classList.add(utilities.modifiers.display.none)
      }
    }
  }
})

export default element => {
  onClick.listen(element)
}
